import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import {register} from '@shopify/theme-sections';
import Product from '../ui/product-types/base';

register('product', Product);

/**
 * Wholesale Customer Variant Selector
 */

const getWholesaleInventory = (inputString) => {
  const keyValuePairs = inputString.split(',');
  const result = {};

  keyValuePairs.forEach(pair => {
      const [key, value] = pair.split(':');
      result[key] = value;
  });

  return result;
}

const setQuantity = (disable = true, key = null) => {
  const wholesaleInventoryElement = document.querySelector('.wholesale-inventory');
  if (!wholesaleInventoryElement) return;

  const wholesaleInventory = getWholesaleInventory(wholesaleInventoryElement.value);
  let quantityIterations = 0;
  if (key) {
    quantityIterations = +wholesaleInventory[key];
  } else {
    quantityIterations = +Object.values(wholesaleInventory)[0];
  }
  quantityIterations = quantityIterations > 20 ? 20 : quantityIterations;

  let quantityOptions = `<option class="options__dropdown-item" value>Quantity</option>`
  for (let index = 1; index < quantityIterations + 1; index++) {
    quantityOptions = quantityOptions + `<option class="options__dropdown-item" value="${index}">${index}</option>`
  }

  const wholesaleQuantityDropdown = document.querySelector('.options__dropdown--Quantity');
  wholesaleQuantityDropdown.innerHTML = quantityOptions;
  wholesaleQuantityDropdown.value = ''

  const hasDisabled = wholesaleQuantityDropdown.hasAttribute("disabled")
  if (disable) {
    !hasDisabled && wholesaleQuantityDropdown.setAttribute("disabled", "disabled")
  } else {
    hasDisabled && wholesaleQuantityDropdown.removeAttribute("disabled");
  }
}

const handleWholesaleButtonClick = (event) => {
  const wholesaleOptionsContainer = document.querySelector('.options--wholesale');
  const wholesaleOptions = document.querySelectorAll('[data-wholesale-option]');
  const errorOptions = [];
  wholesaleOptions.forEach((wholesaleOption) => {
    const optionValue = wholesaleOption.value;
    if (optionValue === '' || optionValue === null) {
      const optionName = wholesaleOption.getAttribute('data-wholesale-option');
      errorOptions.push(optionName);
    }
  })

  if (errorOptions.length > 0) {
    event.preventDefault();
    let wholesaleMessageElement = document.querySelector('[data-wholesale-message]');
    if (wholesaleMessageElement) {
      let wholesaleMessage = wholesaleMessageElement.getAttribute('data-wholesale-message');
      if (errorOptions.length > 1) {
        wholesaleMessage = wholesaleMessageElement.getAttribute('data-wholesale-message-multiple');
      }
      wholesaleMessage = `${wholesaleMessage} ${errorOptions.join(' & ')}`;
      wholesaleMessageElement.innerHTML = wholesaleMessage;
      wholesaleOptionsContainer.classList.add('need-selection');
    }
  } else {
    wholesaleOptionsContainer.classList.remove('need-selection');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const wholesaleSizeDropdown = document.querySelector('.options__dropdown--Size');
  if (wholesaleSizeDropdown) {
    wholesaleSizeDropdown.removeAttribute("disabled");
    wholesaleSizeDropdown.addEventListener('change', (event) => {
      if (event.target.value !== '') {
        setQuantity(false, event.target.value)
      } else {
        setQuantity()
      }
    });
  } else {
    setQuantity(false)
  }

  const wholesaleAddButton = document.querySelector('[data-wholesale-add-button]');
  if (wholesaleAddButton) {
    wholesaleAddButton.addEventListener('click', (event) => {
      handleWholesaleButtonClick(event)
    });
  }
});

/**
 * Related product slider
 */

document.addEventListener('DOMContentLoaded', () => {
  const relatedProductsSelector = '.swiper--related-products';
  const relatedProductsSliderOptions = {
    // Mobile (Default)
    slidesPerView: 3.5,
    centeredSlides: false,
    spaceBetween: 10,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    // Desktop
    breakpoints: {
      927: {
        slidesPerView: 4
      },
    },
    // Navigation
    navigation: {
      nextEl: '.swiper-button-next-related-products',
      prevEl: '.swiper-button-prev-related-products',
    }
  }
  // const relatedProductsSliderOptions = {
  //   type: 'slider',
  //   perView: relatedProductsPerView,
  //   gap: 10,
  //   bound: true,
  //   swipeThreshold: 80,
  //   dragThreshold: 120,
  //   perSwipe: '|',
  //   peek: {
  //     before: 0,
  //     after: 0
  //   },
  //   navigation: {
  //     prevEl: '.glide__arrow--prev',
  //     nextEl: '.glide__arrow--next'
  //   },
  //   breakpoints: {
  //     927: {
  //       type: 'slider',
  //       perView: relatedProductsPerViewMobile,
  //       swipeThreshold: 120,
  //       dragThreshold: 160,
  //       perSwipe: '|',
  //       peek: {
  //         before: 0,
  //         after: 30
  //       }
  //     }
  //   }
  // };

  const relatedProductsElement = document.querySelector(relatedProductsSelector);
  if (!relatedProductsElement) return;

  let relatedProductsSlider = new Swiper(relatedProductsSelector, relatedProductsSliderOptions);
});
